function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "question-outline_inline_svg__Page-13",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "question-outline_inline_svg__01-\\u9996\\u9801---country---s0-v1",
  transform: "translate(-994 -28)",
  fill: "#47AAFF"
}, React.createElement("g", {
  id: "question-outline_inline_svg__Atoms-/-Icon-/-question-/-solid",
  transform: "translate(994 28)"
}, React.createElement("path", {
  d: "M12 4a8 8 0 110 16 8 8 0 010-16zm0 10.71a.903.903 0 100 1.806.903.903 0 000-1.806zm-.01-7.226c-1.447 0-2.26.565-2.944 1.443a.387.387 0 00.086.554l.423.295.075.041c.156.064.341.02.45-.117.481-.615.97-.926 1.91-.926 1.28 0 1.852.652 1.852 1.297 0 1.413-2.498 1.196-2.498 3.465v.012l.008.078c.036.177.192.31.38.31h.515l.078-.008a.387.387 0 00.31-.38v-.012l.01-.15c.171-1.25 2.488-1.22 2.488-3.315 0-1.627-1.456-2.587-3.144-2.587z",
  id: "question-outline_inline_svg__Combined-Shape"
}))));

function SvgQuestionOutlineinline(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgQuestionOutlineinline;